import Vue from 'vue';
import { io } from 'socket.io-client';

Vue.prototype.$socket = io(process.env.VUE_APP_URL_SOCKET);
